import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityDetectedApplicationsActiveTokens } from '@api/data-security';
import { updateApplicationReferences } from '../../applications/_idMap/actions';
import { UpdateDataSecurityApplicationReferenceRequest } from '@types';

export const getCoreDataSecurityDetectedApplicationsActiveTokensSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			(response) => {
				const applications: Array<UpdateDataSecurityApplicationReferenceRequest> =
					Object.keys(response).reduce<Array<UpdateDataSecurityApplicationReferenceRequest>>((acc, key) => {
						const appId = Number(key);

						if (!appId || isNaN(appId)) {
							return acc;
						}

						const newApp = {
							activeTokens: response[ appId ],
							applicationId: appId
						};

						return [ ...acc, newApp ];
					}, [ ]);

				return updateApplicationReferences(applications);
			}
		]
	},
	name: 'CoreDataSecurityDetectedApplicationsActiveTokens',
	receive: true,
	request: true,
	requestHandler: getDataSecurityDetectedApplicationsActiveTokens,
	retainDataOnRequest: true
});
